var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.updatedUser || _vm.createdUser)?_c('el-tooltip',{attrs:{"effect":"dark","placement":"top"}},[_c('div',{staticStyle:{"width":"260px"},attrs:{"slot":"content"},domProps:{"innerHTML":_vm._s(_vm.getUsersInfo)},slot:"content"}),_c('em',{class:`fa fa-user-secret ${_vm.mt}`,staticStyle:{"cursor":"help"},attrs:{"aria-hidden":"true"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }